import { Component, HostListener, OnInit } from '@angular/core';
import { SesionService } from 'src/app/core/service/sesion.service';
import { TaxValidation } from '../tax-validation/model/tax-validation';
import { PotentialCustomer } from '../potential-customer/model/potential-customer';
import {
  FileSave,
  UploadScreenInfo,
} from 'src/app/shared/components/atoms/file-upload-component/model/file-uplaod.interface';
import { SalesValidation } from '../sales-validation/model/sales-validation.interface';
import { ContactInformation, UploadFileContactInformation } from '../contact-information/model/potential-customer';
import { FileToSaveData, RegisterCompleteService, InfoClienteDocumentUpload } from './service/register-complete.service';
import {
  ClientFileInfo,
  OptionAtributte,
  Customer,
  CustomerAddress,
  TaxInformation,
  AdditionalInformation,
  ContactInformationRequest,
} from './model/register-complete';

@Component({
  selector: 'app-register-complete',
  templateUrl: './register-complete.component.html',
  styleUrls: ['./register-complete.component.scss'],
})
export class RegisterCompleteComponent implements OnInit {
  percentage: number = 0;
  taxValidationData: TaxValidation | null;
  potentialCustomerData: PotentialCustomer | null;
  salesValidationData?: SalesValidation | null;
  uploadFileData: UploadScreenInfo | null;
  contacInformation: ContactInformation | null;
  uploadFileOptional: UploadFileContactInformation | null;
  salesValidation: SalesValidation | null;
  cantFiles: number = 0;
  filesSave: FileToSaveData[] = [];
  infoClientFile: ClientFileInfo | undefined;
  constructor(private readonly sesion: SesionService, private readonly service: RegisterCompleteService) {
    this.percentage = 0;
    this.potentialCustomerData = this.sesion.getItem('potential_customer');
    this.salesValidation = this.sesion.getItem('sales_validation');
    this.taxValidationData = this.sesion.getItem('tax_validation');

    this.uploadFileData = {
      fileDoc: [],
      ciValidationRequired: false,
    };
    this.uploadFileOptional = {};
    this.service.getUploadFile().subscribe((data) => {
      this.uploadFileData = data;
    });
    this.service.getPremisesPhoto().subscribe((data) => {
      this.uploadFileOptional = data;
    });
    this.contacInformation = JSON.parse(this.sesion.getItem('contact-information') ?? '{}') as ContactInformation;
  }

  ngOnInit(): void {
    this.percentage = 0;
    this.saveInfo();
  }

  removeAccents(accentedText: string): string {
    const unaccentedText = accentedText.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    console.log(unaccentedText + ' - ' + accentedText);
    return unaccentedText;
  }

  saveInfo() {
    if (this.salesValidation && this.potentialCustomerData && this.taxValidationData && this.contacInformation) {
      let deliveryTimeMorning: string = this.contacInformation.timeA.start + ' to ' + this.contacInformation.timeA.end;
      let deliveryTimeEvening: string = this.contacInformation.timeB.start + ' to ' + this.contacInformation.timeB.end;

      let customerAddress: CustomerAddress = {
        country: 'paraguay',
        state: this.removeAccents(this.potentialCustomerData.location.state),
        city: this.removeAccents(this.potentialCustomerData.location.city),
        street: this.removeAccents(this.potentialCustomerData.location.street),
        latitude: String(this.potentialCustomerData.location.coordinates.lat),
        longitude: String(this.potentialCustomerData.location.coordinates.lon),

        betweenStreets: this.potentialCustomerData.location.entreCalles,

        floorUnitDepartment: this.potentialCustomerData.location.depto ? this.potentialCustomerData.location.depto : '',
      };

      let identificationType = this.taxValidationData.ruc ? 'RUC' : 'CI';
      let taxInformation: TaxInformation = {
        personType: this.taxValidationData.typePerson ? this.taxValidationData.typePerson : 'F',
        identificationNumber: this.taxValidationData.ruc ? this.taxValidationData.ruc : this.taxValidationData.ci,
        identificationType: identificationType,
        attachedDocumentType: this.setAttach(),
        dniValidationRequired: this.uploadFileData?.ciValidationRequired
          ? this.uploadFileData?.ciValidationRequired
          : false,
        lastname: this.taxValidationData.surname,
        name: this.taxValidationData.name,
      };
      if (identificationType == 'RUC') {
        taxInformation.numberCedulaIdentidad = this.taxValidationData.ci;
      }

      let additionalInformation: AdditionalInformation = {};

      let contactInformationRequest: ContactInformationRequest = {
        email: this.contacInformation.email,
        phoneNumber: this.contacInformation.telephone,
        scheduleContactMorning: deliveryTimeMorning,
        scheduleContactEvening: deliveryTimeEvening,
      };

      if (this.contacInformation.secondaryTelephone) {
        contactInformationRequest.phoneNumSecondary = this.contacInformation.secondaryTelephone;
      }
      let nameComplete = '';
      if (this.taxValidationData.socialReason) {
        nameComplete = this.taxValidationData.socialReason;
      } else if (this.taxValidationData.name || this.taxValidationData.surname) {
        nameComplete = this.taxValidationData.surname + ' ' + this.taxValidationData.name;
      }
      let data: Customer = {
        companyName: nameComplete,
        fantasyName: this.potentialCustomerData.fantasyName,
        requestDate: new Date(),
        treeAnswersFinalId: this.salesValidation.idAnswersFinal,
        customerAddress: customerAddress,
        additionalInformation: additionalInformation,
        contactInformation: contactInformationRequest,
        taxInformation: taxInformation,
      };
      this.service.saveInfo(data).subscribe((resp) => {
        this.saveFile(resp.newCustomerId, resp.customerRequestId);
      });
    }
  }

  saveFile(newCustomerId: number, customerRequestId: number) {
    // se guardan las otras lambdas que no son la de archivos
    this.setInfoClientFile(newCustomerId, customerRequestId);
    if (this.uploadFileData) {
      for (let fileDocData of this.uploadFileData.fileDoc) {
        if (fileDocData.files != null) {
          this.addFile(fileDocData.files);
        }
      }
      if (this.uploadFileOptional?.uploadFile0) {
        this.addFile(this.uploadFileOptional?.uploadFile0);
      }
      if (this.uploadFileOptional?.uploadFile1) {
        this.addFile(this.uploadFileOptional?.uploadFile1);
      }
      this.uploadFiles();
    }
  }

  @HostListener('window:beforeunload', ['$event'])
  beforeunloadHandler(event: { returnValue: boolean }) {
    if (this.percentage < 100) {
      event.returnValue = true;
    }
  }

  addFile(filesDto: FileSave[]) {
    this.cantFiles += filesDto.length;
    for (let file of filesDto) {
      const filename = file.name;
      const contentType = file.type;
      this.filesSave.push({
        documentTypeId: file.id,
        fileData: {
          contentType,
          filename,
        },
      });
    }
  }

  setInfoClientFile(newCustomerId: number, customerRequestId: number) {
    if (this.taxValidationData?.ruc || this.taxValidationData?.ci) {
      this.infoClientFile = {
        ruc: this.taxValidationData?.ruc
          ? String(this.taxValidationData?.ruc.replace(/-/g, ''))
          : String(this.taxValidationData?.ci),
        customerId: newCustomerId,
        requestId: customerRequestId,
        documentTypeId: 1,
      };
    }
  }

  dataURItoBlob(dataURI: any) {
    const byteString = window.atob(dataURI);
    const arrayBuffer = new ArrayBuffer(byteString.length);
    const int8Array = new Uint8Array(arrayBuffer);
    for (let i = 0; i < byteString.length; i++) {
      int8Array[i] = byteString.charCodeAt(i);
    }
    const blob = new Blob([int8Array], { type: 'image/png' });
    return blob;
  }

  uploadFiles() {
    const infoCliente: InfoClienteDocumentUpload = {
      identificationNumber: this.infoClientFile?.ruc,
      customerId: this.infoClientFile?.customerId,
      requestId: this.infoClientFile?.requestId,
    };
    this.service.organizeFiles(this.filesSave, infoCliente).subscribe(() => {
      this.percentage = 100;
      this.service.deleteStore();
      this.service.deleteSessionStore();
    });
  }

  setAttach(): OptionAtributte[] {
    // Logica de constancia de cuil y constancia de IIBB en arg
    let option: OptionAtributte[] = [];
    return option;
  }

  getDocumentType(): string {
    return this.taxValidationData!.ruc ? 'CI' : 'RUC';
  }
}
